<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">End Of Day Items</h4>
            <EodInfoCard />
            <!-- Supposed Form -->
            <div class="form-body">
              <EodItemsTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import EodItemsTable from "../../../components/Kleyton/Tables/Report/EOD/EodItemsTable";
import EodInfoCard from "../../../components/Kleyton/Cards/Report/EOD/EodInfoCard";

export default {
  name: "EodItems",
  page: {
    title: "End Of Day Items",
    meta: [{ name: "End Of Day Items", content: window.__env.app.description }]
  },
  components: {
    EodInfoCard,
    EodItemsTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "End Of Day Items",

      items: [
        {
          text: "Report",
          href: "/"
        },
        {
          text: "End Of Day Items",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>

<style scoped></style>
